import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Alert } from 'react-bootstrap';
import { FaTasks, FaSlack, FaClock, FaCheckCircle } from 'react-icons/fa';
import TrendsGraph from '../../components/graph/Graph';
import axios from 'axios';
import Cookies from 'js-cookie';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function QuickStatsGrid() {
  const [statsData, setStatsData] = useState({
    todayTasks: 0,
    slackRepliesPending: 0,
    avgResponseDelayHours: 0,
    tasksCompletedThisWeek: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);
      setError(null);
      try {
        // Ensure the API URL is defined
        const apiUrl = process.env.REACT_APP_API_URL;
        if (!apiUrl) {
          throw new Error('REACT_APP_API_URL is not defined in environment variables.');
        }
        const token = Cookies.get("token");
        if (!token) {
          throw new Error('Authentication token not found in cookies.');
        }
        const res = await axios.get(`${apiUrl}/api/tasks`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          timeout: 10000,
        });

        if (res.data.success) {
          setStatsData(res.data.stats);
        } else {
          throw new Error('API response indicated failure.');
        }
      } catch (err) {
        console.error('Failed to fetch task stats:', {
          message: err.message,
          status: err.response?.status,
          data: err.response?.data,
        });
        setError('Unable to load stats. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const stats = [
    {
      title: "Today's Tasks",
      value: statsData.todayTasks,
      description: "Tasks that are due today.",
      icon: <FaTasks className="text-primary" style={{ fontSize: '1.5rem' }} />,
    },
    {
      title: "Slack Replies Pending",
      value: statsData.slackRepliesPending,
      description: "Mentions with no replies yet.",
      icon: <FaSlack className="text-primary" style={{ fontSize: '1.5rem' }} />,
    },
    {
      title: "Avg. Response Delay",
      value: `${statsData.avgResponseDelayHours}h`,
      description: "Average time taken to respond.",
      icon: <FaClock className="text-primary" style={{ fontSize: '1.5rem' }} />,
    },
    {
      title: "Tasks Completed This Week",
      value: statsData.tasksCompletedThisWeek,
      description: "Total completed this week.",
      icon: <FaCheckCircle className="text-primary" style={{ fontSize: '1.5rem' }} />,
    },
  ];

  return (
    <>
      {error && (
        <Alert variant="danger" onClose={() => setError(null)} dismissible>
          {error}
        </Alert>
      )}
      <Row className="d-flex align-items-stretch mb-4">
        {loading ? (
          // Render four Skeleton placeholders during loading
          Array.from({ length: 4 }).map((_, index) => (
            <Col md={3} className="mb-4" key={`skeleton-${index}`}>
              <Skeleton height={120} width="100%" className="rounded" />
            </Col>
          ))
        ) : (
          stats.map((stat, index) => (
            <Col md={3} className="mb-4" key={index}>
              <Card style={{ height: '120px' }}>
                <Card.Body className="d-flex flex-column">
                  <div className="d-flex align-items-center mb-2">
                    {stat.icon}
                    <Card.Title className="ms-2 mb-0" style={{ fontSize: '1rem' }}>
                      {stat.title}
                    </Card.Title>
                  </div>
                  <Card.Text className="mb-1" style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
                    {stat.value}
                  </Card.Text>
                  <Card.Text className="text-muted" style={{ fontSize: '0.75rem' }}>
                    {stat.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))
        )}
      </Row>
      <TrendsGraph />
    </>
  );
}